// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--UQBju","info":"_103a151b99--info--Jjgwo","name":"_103a151b99--name--nHQY0","size":"_103a151b99--size--WbxmL"};